import Licensee, { SHIPPING_ADDRESS_TYPE } from "@/model/licensee.mjs";
import { keyType } from "@/queue/types";
import { adminTabs, defaultConfig, typeList } from "./constants";
import moment from "moment";
import { addressType } from "@/dealerProfile/types";

export const createTransferInitValue = {
  referenceId: '',
  buyerName: '',
  notes: '',
  firearm: '',
  orderDate: new Date(),
  storeURL: '',
  buyerPhone: '',
  buyerEmail: '',
  modelType: '',
  street: '',
  city: '',
  state: '',
  zipCode: '',
  key: ''
};

export const getDefaultShippingAddress = (licenseDetails: Licensee) => {
  const defaultShippingAddress = licenseDetails.defaultShippingAddress || {
    type: SHIPPING_ADDRESS_TYPE.PREMISE
  };
  let shippingType = defaultShippingAddress?.type
    ? SHIPPING_ADDRESS_TYPE[defaultShippingAddress.type as keyType<typeof SHIPPING_ADDRESS_TYPE>] ||
    SHIPPING_ADDRESS_TYPE.PREMISE
    : SHIPPING_ADDRESS_TYPE.PREMISE;
  const premiseAddress = licenseDetails?.contact?.address;
  const mailAddress = licenseDetails.contact.mailAddress;
  const customAddresses = licenseDetails.customAddress;
  if (
    shippingType === SHIPPING_ADDRESS_TYPE.CUSTOM &&
    defaultShippingAddress?.id
  ) {
    if (customAddresses && customAddresses.length > 0) {
      const matchedAddress = customAddresses.find(
        (customAddress) => String(defaultShippingAddress?.id) === String(customAddress.id)
      );
      if (matchedAddress) {
        const { street, state, city, zipcode } = matchedAddress;
        return {
          address: { street, state, city, zipCode: zipcode },
          type: SHIPPING_ADDRESS_TYPE.CUSTOM
        };
      }
    }
  }

  if (mailAddress && shippingType === SHIPPING_ADDRESS_TYPE.MAILING) {
    const { street, state, city, zip } = mailAddress;
    return {
      address: { street, state, city, zipCode: zip },
      type: SHIPPING_ADDRESS_TYPE.PREMISE
    };
  }

  if (premiseAddress) {
    const { street1, state, city, zip } = premiseAddress;
    return {
      address: { street: street1, state, city, zipCode: zip },
      type: SHIPPING_ADDRESS_TYPE.PREMISE
    };
  }
  return { type: '', address: null };
};

export function getOpeningDayLabel(openingHours: any[]) {
  const openDays = openingHours
    .filter((day) => !day.toLowerCase().includes('closed'))
    .map((day) => day.split(':')[0]);

  if (openDays.length === 0) return 'Closed all week';
  if (openDays.length === 7) return 'Monday - Sunday';
  if (
    openDays.length === 5 &&
    openDays[0] === 'Monday' &&
    openDays[openDays.length - 1] === 'Friday'
  )
    return 'Monday–Friday';

  return openDays.length > 0
    ? `${openDays[0]}-${openDays[openDays.length - 1]}`
    : 'Closed';
}

export const getLicenseType = (object: typeof typeList, value: string) =>  {
  return (
    Object.keys(object).find(
      (key) => object[key as keyType<typeof object>] === value
    ) || '-'
  );
}

export const IsUUID = (string: string) => {
  const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return regex.test(string);
}

export const maskValue = (value:string, lastCharactersToShow:number, numberOfStars:number) => {
  const symbol = "*";
  return symbol.repeat(numberOfStars) + value.substring(value.length - lastCharactersToShow);
}

export const maskLicense = (license: string) => {
  let key = license;

  key =  replaceAt(license, 3, "-XXX-XX-XX-");
  key= replaceAt(key,1,"-")
  return key
}

export const formatPhoneNumber = (phone?: string | null) => {
  if(!phone) return "-"
  let key = phone;

  key =  replaceAt(key, 6, "-");
  key =  replaceAt(key, 3, "-");
  
  return key
}
export const formatPhoneNumberWithoutDuplicate = (phone?: string | null) => {
  if(!phone) return "-"
  let key = phone;
  key = key.replaceAll('-', '');
  key =  replaceAt(key, 6, "-");
  key =  replaceAt(key, 3, "-");
  
  return key
}
export const removeHyphen = (phone?: string | null) => {
  if(!phone) return ""
  phone = phone.replaceAll('-', '');
  return phone;
}
export const replaceAt = (text: string, index: number, replacement: string) => {
  return text.slice(0, index) + replacement + text.slice(index);
};

export const removedDashFromNumber = (controlNumber: string) => {
  return controlNumber ? controlNumber.replace(/-/g, '') : '';
}
export const validateEmail = (email?: string | null) => {
  if(!email) return false
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}
export const validatePhone = (phone?: string | null) => {
  if(!phone) return false
  const regex = /^[0-9]*$/;
  return regex.test(phone) && phone.length !== 10
}

export const validateWebsite = (value?: string | null) => {
  if(!value) return false
  const regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
  return regex.test(value)
}

export const validateCityAndState = (value?: string | null) => {
  if (!value) return false;
  const regex = /^[A-Za-z\s-]+$/;

  return regex.test(value)

}

export const convertISTtoUTCtime = (date: string) => {
  if(date){
    const localDate = new Date(date);
    return `${localDate.getUTCFullYear()}-${String(localDate.getUTCMonth() + 1).padStart(2, '0')}-${String(localDate.getUTCDate()).padStart(2, '0')} ${String(localDate.getUTCHours()).padStart(2, '0')}:${String(localDate.getUTCMinutes()).padStart(2, '0')}:${String(localDate.getUTCSeconds()).padStart(2, '0')}`;
  }
  return "";
}

export const getDynamicDuration = (start: string, end: string) => {
  if(!start || !end) return '';

  const startDate = moment(start);
  const endDate = moment(end);

  const diffMs = endDate.diff(startDate);
  const duration = moment.duration(diffMs);

  if (Math.ceil(duration.asSeconds()) == 1) {
    return `${Math.ceil(duration.asSeconds())} s`;
  } else if (duration.asSeconds() < 60) {
    return `${Math.ceil(duration.asSeconds())} s`;
  } else if (Math.ceil(duration.asMinutes()) == 1) {
    return `${Math.ceil(duration.asMinutes())} m`;
  } else if (duration.asMinutes() < 60) {
    return `${Math.ceil(duration.asMinutes())} m`;
  } else if (Math.ceil(duration.asHours()) == 1) {
    return `${Math.ceil(duration.asHours())} h`;
  } else if (duration.asHours() < 24) {
    return `${Math.ceil(duration.asHours())} h`;
  } else if (Math.ceil(duration.asDays()) == 1) {
    return `${Math.ceil(duration.asDays())} d`;
  } else if (duration.asDays() < 30) {
    return `${Math.ceil(duration.asDays())} d`;
  } else if (Math.ceil(duration.asMonths()) == 1) {
    return `${Math.ceil(duration.asMonths())} month`;
  } else if (duration.asMonths() < 12) {
    return `${Math.ceil(duration.asMonths())} months`;
  } else {
    return '';
  }
};
export const checkIsStateCA = (state: string | undefined) => {
  return state ? state?.trim()?.toLowerCase()?.includes('ca') : false;
}

export function filterDerivedValues(
  derivedValues: string[],
  macroStatus: any
): string[] {
  // Get all the keys from the macroStatus object
  const macroKeys = Object.keys(macroStatus);

  // Collect all child keys from the macroStatus
  const allKeysToRemove = new Set(
    macroKeys.concat(
      ...macroKeys.map((key) => Object.keys(macroStatus[key] || {}))
    )
  );

  // Filter the derived values to exclude any that match the top-level or child keys
  return derivedValues.filter((value) => !allKeysToRemove.has(value));
}
export function findMatchingTopLevelKey(
  derivedValues: string[],
  macroStatus: any
): string  {
  // Get all the top-level keys from the macroStatus object
  const macroKeys = Object.keys(macroStatus);

  // Find the first top-level key that exists in the derivedValues array
  const matchingKey = macroKeys.find((key) => derivedValues.includes(key));

  return matchingKey || 'all';
}

export const flattenTransferMacroSubStatus = (input: any) => {
  return Object.values(input).reduce((acc:any, curr:any) => {
    return { ...acc, ...curr };
  }, {});
};
export  const isNotEmptyObject = (obj: Record<string, any>): boolean => {
  return obj && Object.keys(obj).length > 0;
};

export const hoursToMinutes = (hours:number)=> {
  const duration = hours * 60;
  return duration
}
export const minutesToHours = (hours:number)=> {
  const duration = hours / 60;
  return duration
}

export const convertInTitleCase = (str: string) => {
  if(!str) return '';
  return str.toLowerCase().replace(/\b\w/g, (char: any) => char.toUpperCase());
}
export const isOutboundFilterDisabled = (filterName: string, filters: any) => {
  if(filters && filters?.derivedStatus && filters?.derivedStatus?.values.length > 0){
    if(filterName === 'tranfer_pending' && filters?.derivedStatus?.values.includes('tranfer_pending') && filters?.derivedStatus?.filterType === 'notEqual'){
      return true
    }
    if(filterName === 'outbound_transfer_complete' && filters?.derivedStatus?.values.includes('outbound_transfer_complete') && filters?.derivedStatus?.filterType === 'notEqual'){
      return true
    }
  }
  return false
}

export const getHideTabs = (isStoreAdmin: boolean, isStoreAgent: boolean, permissions: any) => {
  if (permissions && Object.keys(permissions)?.length > 0 && (isStoreAdmin || isStoreAgent)) {
    return Object.entries(permissions)
      .filter(([key, value]: [key: string, value: any]) => {
        if (key === 'profileEdit' && typeof value === 'object' && !Array.isArray(value)) {
          return !value?.editOthers && !value?.editSelf;
        }
        return Array.isArray(value) && value.length === 0
  })
      .map(([key]) => key);
  }
  return [];
}

export const getHideSubTabs = (isStoreAdmin: boolean, isStoreAgent: boolean, permissions: any) => {
  if (permissions && Object.keys(permissions)?.length > 0 && (isStoreAdmin || isStoreAgent)) {
  const hiddenTabs: string[] = [];

  Object.keys(defaultConfig).forEach(key => {
    const defaultValue = defaultConfig[key];
    const currentValue = permissions[key];
    if (key === 'profileEdit') {
      if (typeof defaultValue === 'object' && !Array.isArray(defaultValue) && 
          typeof currentValue === 'object' && !Array.isArray(currentValue)) {
        
        Object.keys(defaultValue).forEach(prop => {
          if (defaultValue[prop] === true && currentValue[prop] === false) {
            hiddenTabs.push(prop);
          }
        });
      }
    } 
    else if (Array.isArray(defaultValue)) {
      const currentSubTabs = Array.isArray(currentValue) ? currentValue : [];
      defaultValue.forEach((tab: any) => {
        if (!currentSubTabs.includes(tab)) {
          hiddenTabs.push(tab);
        }
      });
    }
    });
    return [...new Set(hiddenTabs)]; // Remove duplicates
  }
  return [];
}

export const getFormattedAdminTabs = ( hideTabs: string[], tabName: string) => {
  // Filter out hidden tabs
  const tabs = adminTabs;
  const filteredTabs = Object.entries(tabs)
    .filter(([key]) => !hideTabs.includes(key))
    .reduce((acc, [key, value], index) => {
      return {
        ...acc,
        [key]: {
          ...(value as object),
          id: String(index)
        }
      };
    }, {});

  // Find and return the ID of the matching tab
  const matchingTab: any = Object.values(filteredTabs)
    .find((tab: any) => tab.tab === tabName);
  return matchingTab ? matchingTab.id : '0';
};
export const getAdminTabPath = (hideTabs: string[], pathId?: string) => {
  // Filter out hidden tabs
  const tabs = adminTabs;
  const filteredTabs = Object.entries(tabs)
    .filter(([key]) => !hideTabs.includes(key))
    .reduce((acc, [key, value], index) => {
      return {
        ...acc,
        [key]: {
          ...value ,
          id: String(index)
        }
      };
    }, {});

  const filteredTabsArray = Object.values(filteredTabs) as { tab: string }[];
  if(pathId){
    const matched = filteredTabsArray.find(t => t.tab === pathId);
    if (matched) return `/admin/${matched.tab}`;
  }
  const first = filteredTabsArray[0];
  return first ? `/admin/${first.tab}` : '/admin/manage-users';
};

export function hasAddressChanged(license: any) {
  // Helper function to compare two address objects
  const compareAddresses = (currentAddress: any, oldAddress: any) => {
    if (!currentAddress || !oldAddress) {
      return false;
    }

    // Compare all address fields
    const fieldsToCompare = ['state', 'zipCode', 'street', 'city', 'citySlug'];
    
    return fieldsToCompare.some(field => {
      const currentValue = currentAddress[field]?.trim();
      const oldValue = oldAddress[field]?.trim();
      if(!oldValue){ return false }
      return currentValue !== oldValue;
    });
  };

  // Check premise address changes
  const isPremiseAddressChanged = license.oldPremiseAddress && 
    compareAddresses(license.premiseAddress, license.oldPremiseAddress);

  // Check mailing address changes
  const isMailingAddressChanged = license.oldMailingAddress && 
    compareAddresses(license.mailingAddress, license.oldMailingAddress);

  return {
    isPremiseAddressChanged: !!isPremiseAddressChanged,
    isMailingAddressChanged: !!isMailingAddressChanged,
    hasAnyAddressChanged: isPremiseAddressChanged || isMailingAddressChanged
  };
};

export function hasNameChanged(license: {
  licenseNameChangedDate?: string | null;
  businessNameChangedDate?: string | null;
  oldLicenseName?: string | null;
  oldBusinessName?: string | null;
  licenseName?: string | null;
  businessName?: string | null;
}) {
  if (!license) return { isLicenseNameChanged: false, isBusinessNameChanged: false, hasAnyNameChanged: false };
  const isLicenseNameChanged = !!license.licenseNameChangedDate;
  const isBusinessNameChanged = !!license.businessNameChangedDate;
  return {
    isLicenseNameChanged,
    isBusinessNameChanged,
    hasAnyNameChanged: isLicenseNameChanged || isBusinessNameChanged
  };
}

export function getFormattedAddress(value?: addressType) {
  if (!value) return '-';
  
  // Check if any of the required address components exist
  if (!value.street && !value.city && !value.state && !value.zipCode) {
    return '-';
  }
  
  // Filter out empty/null/undefined values and join them
  const addressParts = [
    value.street,
    value.city,
    value.state,
    value.zipCode
  ].filter(part => part && part.trim() !== '');
  
  // If no valid parts exist, return dash
  if (addressParts.length === 0) {
    return '-';
  }
  
  // Format the address properly
  const streetPart = value.street ? value.street.trim() : '';
  const cityStatePart = [value.city, value.state].filter(part => part && part.trim() !== '').join(', ');
  const zipPart = value.zipCode ? value.zipCode.trim() : '';
  
  const formattedParts = [streetPart, cityStatePart, zipPart].filter(part => part !== '');
  
  return formattedParts.join(', ') || '-';
}
export const  getFormattedTextForManualReview = (performedBy: string | null, emailData: any) => {
  
  const actionPerformedBy: any = {
    System: 'backend',
    Agent: 'profile',
    Dealer: 'dealer',
    system: 'backend',
    agent: 'profile',
    dealer: 'dealer',
    Support: 'profile',
    support: 'profile',
    SMS: 'dealer',
    sms: 'dealer',
    email_campaign: 'email',
    ffl360: 'profile'
  }
  const email = emailData?.manual_review_requested_by && emailData?.manual_review_requested_by !==null ? emailData?.manual_review_requested_by : '';
  if (performedBy && performedBy !== null) {
    if (performedBy?.toLowerCase() === "email_campaign") {
      return ` Via Dealer ${email}`;
    }
    if (performedBy?.toLowerCase() === "dealer" || performedBy?.toLowerCase() === "upload_ui") {
      return `Via Dealer ${email}` ;
    }
    if (actionPerformedBy[performedBy]) {
      return `Via ${actionPerformedBy[performedBy]} ${email}`;
    }
    return ''
  }
  return ''
}

export const validateRedirectUrl = (value?: string | null): string => {
  // 1. If empty/null/undefined, return no error
  if (!value) return '';
  
  // 2. Check URL pattern with regex
  const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,}(:\d+)?([/?]\S*)?$/i;
  
  if (!urlRegex.test(value)) {
      return 'Please enter a valid URL e.g., https://example.com';
  }
  
  // 3. Check www rule (www needs at least 2 dots)
  const hostname = value.replace(/^https?:\/\//, '').split(/[/:]/)[0];
  
  if (hostname.startsWith('www.') && hostname.split('.').length < 3) {
      return 'Please enter a valid URL';
  }
  
  return '';
}

export function getSourceTextForApprovalPage(source: string | undefined, type: string) {
    switch (source) {
      case 'ffl360':
        return  `${type} uploaded by FFL360 users through the dealer profile interface.`;
      case 'upload_ui':
        return `${type} uploaded directly by the dealer, typically during a transfer process.`;
      case 'backend':
        return `${type} manually added by our internal team through the backend system.`;
      case 'email_campaign':
        return `${type} uploaded by the dealer in response to a campaign email request.`;
      case 'email':
        return `${type} received via email at either license@masterffl.com or licenses@masterffl.com.`;
      case 'myffl':
        return `${type} uploaded via MyFFL`;
    }
    return `${type} manually added by our internal team through the backend system.`;
  }